/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MailBankSendWelcomeEmailRequest
 */
export interface MailBankSendWelcomeEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof MailBankSendWelcomeEmailRequest
     */
    courierId?: string;
    /**
     * 
     * @type {string}
     * @memberof MailBankSendWelcomeEmailRequest
     */
    userId?: string;
}

/**
 * Check if a given object implements the MailBankSendWelcomeEmailRequest interface.
 */
export function instanceOfMailBankSendWelcomeEmailRequest(value: object): value is MailBankSendWelcomeEmailRequest {
    return true;
}

export function MailBankSendWelcomeEmailRequestFromJSON(json: any): MailBankSendWelcomeEmailRequest {
    return MailBankSendWelcomeEmailRequestFromJSONTyped(json, false);
}

export function MailBankSendWelcomeEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailBankSendWelcomeEmailRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
        'userId': json['userId'] == null ? undefined : json['userId'],
    };
}

export function MailBankSendWelcomeEmailRequestToJSON(json: any): MailBankSendWelcomeEmailRequest {
    return MailBankSendWelcomeEmailRequestToJSONTyped(json, false);
}

export function MailBankSendWelcomeEmailRequestToJSONTyped(value?: MailBankSendWelcomeEmailRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'courierId': value['courierId'],
        'userId': value['userId'],
    };
}

